// extracted by mini-css-extract-plugin
export var bottomCopy = "ContentIllustration-module--bottomCopy--63a00";
export var bottomCopyRow = "ContentIllustration-module--bottomCopyRow--25770";
export var bottomLogo = "ContentIllustration-module--bottomLogo--ae455";
export var container = "ContentIllustration-module--container--1a482";
export var copyColumn = "ContentIllustration-module--copyColumn--cc0db";
export var ctaContainer = "ContentIllustration-module--ctaContainer--84310";
export var description = "ContentIllustration-module--description--feca8";
export var headline = "ContentIllustration-module--headline--87d49";
export var image = "ContentIllustration-module--image--b3b2e";
export var imageColumn = "ContentIllustration-module--imageColumn--c8156";
export var subHeadline = "ContentIllustration-module--subHeadline--5d22f";
export var wrapper = "ContentIllustration-module--wrapper--b1e1b";